import React, { useMemo } from "react";
import { FormikFormWrapperForJetpackConfig } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import type { FormikFormChildProps } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import LoyaltyGiftsLanding from "./LoyaltyGiftsLanding";
import LoyaltyTiersGiftsEditor from "./LoyaltyTiersGiftsEditor";
import LoyaltyLeaderboardGiftsEditor from "./LoyaltyLeaderboardGiftsEditor";
import createLoyaltyPrizeValidationSchema from "./helper/loyalty_prize_validation_schema";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";

interface LoyaltyGiftsConfigWrapperProps {
  ChildComponent?: React.ComponentType<FormikFormChildProps>;
}

const LoyaltyGiftsConfigWrapper = ({
  ChildComponent = LoyaltyGiftsLanding
}: LoyaltyGiftsConfigWrapperProps) => {
  const { accountToDisplay } = useAccountToDisplaySelector();

  const validationSchema = useMemo(
    () => createLoyaltyPrizeValidationSchema(accountToDisplay),
    [accountToDisplay]
  );

  return (
    <FormikFormWrapperForJetpackConfig
      validationSchema={validationSchema}
      ChildComponent={
        ChildComponent as React.FunctionComponent<FormikFormChildProps>
      }
    />
  );
};

export default LoyaltyGiftsConfigWrapper;
export { LoyaltyTiersGiftsEditor, LoyaltyLeaderboardGiftsEditor };
